// Datadog drops attributes past its size budget, and the component stacks worth
// bounding (a stack overflow, a runaway recursive render) repeat themselves, so
// the head carries the signal.
const COMPONENT_STACK_LIMIT = 12_000;

/**
 * Prepares a React `ErrorInfo.componentStack` for `recordRumError` context.
 * Error boundaries are the only place the component path is available, and it is
 * often the only usable trace: browsers truncate `error.stack` for stack
 * overflows, and a boundary reporting a message string loses the stack entirely.
 *
 * Lives outside `datadogRum.ts` so tests mocking the RUM wrappers still format
 * component stacks for real.
 *
 * @param componentStack - `ErrorInfo.componentStack` as React provides it
 */
export function truncateComponentStack(
  componentStack: string | null | undefined
): string | undefined {
  if (componentStack == null) {
    return undefined;
  }
  return componentStack.length > COMPONENT_STACK_LIMIT
    ? componentStack.slice(0, COMPONENT_STACK_LIMIT) + '\n… truncated'
    : componentStack;
}
